import "./PricingHeader.css";
import { Navbar } from "../Navbar/Navbar.js";

const PricingHeader = () => {
    return (
        <section className="pricing-hero">
            <Navbar />
            <div className="pricing-hero-content">

                {/* <span className="pricing-tag">Pricing</span> */}

                <h1>Clear, Transparent Pricing</h1>

                <p>
                    Our payment structure is simple and milestone-based.
                    You pay as your project progresses — ensuring complete
                    transparency and peace of mind.
                </p>

                <a href="#pricing" className="pricing-btn">
                    View Pricing Plan
                </a>

            </div>
        </section>
    );
}


export { PricingHeader };